export default "__VITE_ASSET__CHIyw5FL__"